<template>
    <div>
        <h1 style="font-size: 24px; color: black;">源数据日报</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="100px">
                <el-form-item label="应用：">
                    <el-select v-model="queryData.appId" placeholder="请选择"  >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="app in appList"
                                   :key="app.appId"
                                   :label="app.appName"
                                   :value="app.appId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="媒体：">
                    <el-select v-model="queryData.mediaId" placeholder="请选择"  >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="media in mediaList"
                                   :key="media.id"
                                   :label="media.name"
                                   :value="media.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub10" >
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button class="std" type="primary"  @click="exportExcel" :disabled="!isExport">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="dataList"
                      style="width: 100%"
                      border
                      :header-cell-style="{background:'#303133'}"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="需求平台" prop="mediaName" align="center"></el-table-column>
                <el-table-column label="创建时间" align="center">
                    <template slot-scope="scope" >
                        {{formatDate(scope.row.dt,"yyyy-MM-DD")}}
                    </template>
                </el-table-column>
                <el-table-column label="项目名称" prop="appName" align="center"></el-table-column>
                <el-table-column label="项目ID" prop="appId" align="center"></el-table-column>
                <el-table-column label="类型" prop="adTypeName" align="center" ></el-table-column>
                <el-table-column label="代码位详情" prop="placementName" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="收益" prop="revenue" align="center" ></el-table-column>
                <el-table-column label="ECpm" prop="ecpm" align="center" ></el-table-column>
                <el-table-column label="展示" prop="impressions" align="center" ></el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[10,20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        searchBaseData,
        downloadData
    } from "@/http/outApi";
    import utils from '@/utils';
    import settingMix from '@/utils/mix/common-setting'
    export default {
        name: "DataSourceReport",
        mixins: [settingMix],
        data(){
            return{
                queryData:{
                    mediaId:-1,
                    timeDate:['',''],
                    appId: -1
                },
                needGetApp: true,
                needGetMedia:true,
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                dataList:[],
                loading:true,
                appList:[],
                mediaList:[],
                isExport:true
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            exportExcel(){
                this.isExport=false;
                let fileName = new Date().toLocaleString() + '源数据日报.xlsx';
                downloadData(
                    '/report/exportBase',
                    this.queryData,
                    fileName
                ).then(resp=>{
                    console.log(resp);
                    this.isExport = true;
                })
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.loading = true;
                searchBaseData(this.queryData).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        this.dataList=resp.data.info.list;
                        this.page.totalElements =resp.data.info.total;
                    }
                });
            },
        },
        created () {
            this.query();
        }
    }
</script>

<style scoped>

</style>